import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute('/_app/library/processes/')({
  beforeLoad: () => {
    throw redirect({ to: '/library' })
  },
})
